import React from 'react';
import PropTypes from 'prop-types';

const ItemPeopleOffer = ({ offer, person, type }) => {
  const thousands = (num) => {
    return num.toString().split('').reverse().join('')
      .replace(/(?=\d*\.?)(\d{3})/g, '$1,')
      .split('')
      .reverse()
      .join('')
      .replace(/^[,]/, '');
  };
  return (
    <div className="text-left mt-25">
      <div className="d-flex align-items-center text-tangaroa f-600">
        <i className="fas fa-user-circle mr-2 " />
        <div className="">{person}</div>
      </div>
      {type === 'Open' && (
        <div className="text-dark-blue mt-2 ft-12">
          {`${thousands(offer)} Puntos Aeroméxico Rewards`}
        </div>
      )}
      {type === 'Closed' && (
        <div className="text-dark-blue mt-2 ft-12">
          {`${thousands(offer)} Puntos Aeroméxico Rewards`}
        </div>
      )}
    </div>
  );
};

ItemPeopleOffer.propTypes = {
  offer: PropTypes.number.isRequired,
  person: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default ItemPeopleOffer;
